export default __webpack_public_path__ + "static/media/Penguins.e2b4feae.png";